import { useAuth } from '@features/auth/hooks/useAuth';
import { PromotedClubs } from '@features/club/ui/PromotedClubs/PromotedClubs';
import { usePromotedClubs } from '@features/shared/api/public';

const PROMOTED_CLUB_IDS = ['777', '1001', '316'];
const PROMOTED_CLUB_TITLES = ['Клуб РШШ', 'Клуб НСШЛ', 'Королевский Гамбит'];

export function PromotedClubsWidget() {
  const { data: clubs } = usePromotedClubs({ clubIds: PROMOTED_CLUB_IDS });
  const user = useAuth().user;
  const isMemberClubIds = user ? Object.keys(user.clubs) : [];

  const sortedClubs = clubs
    ? PROMOTED_CLUB_IDS.map((id, idx) => {
        const club = clubs.find((c) => c.clubId === id)!;

        return {
          ...club,
          title: PROMOTED_CLUB_TITLES[idx]!,
        };
      })
    : undefined;

  return <PromotedClubs clubs={sortedClubs} isMemberClubIds={isMemberClubIds} />;
}
